<template>
  <div class="faq bg-white py-10">
    <div class="container mx-auto px-4">
      <!-- Заголовок -->
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-2xl font-bold text-gray-800">{{ $t("faq.title") }}</h2>
        <router-link
          :to="{ name: 'category_view', params: { slug: 'qa' } }"
          class="flex items-center gap-1 text-[#222] no-underline text-sm"
        >
          {{ $t("faq.goToQa") }}
          <svg-icon name="arrow-right" class="w-7 h-7 fill-none" />
        </router-link>
      </div>

      <!-- Список вопросов -->
      <div v-if="loading" class="text-center py-8">
        <p>{{ $t("faq.loading") }}</p>
      </div>
      <div v-else-if="error" class="text-center py-8 text-red-500">
        <p>{{ error }}</p>
      </div>
      <div v-else class="space-y-2">
        <div
          v-for="(faq, index) in faqItems"
          :key="faq.id"
          class="bg-gray-100 rounded-2xl p-4 text-gray-800"
          :class="{ 'bg-primary text-white': activeArticleId === faq.id }"
          @click="toggleArticle(faq.id)"
        >
          <div class="flex items-start gap-10">
            <div class="flex gap-4 lg:gap-10 flex-1 font-semibold">
              <span class="text-xl">
                {{ String(index + 1).padStart(2, "0") }}
              </span>
              <div>
                <h3 class="text-xl leading-7">
                  {{ faq.title }}
                </h3>
                <transition name="fade-slide">
                  <div
                    v-if="activeArticleId === faq.id"
                    class="font-medium mt-5"
                    v-html="faq.description"
                  ></div>
                </transition>
              </div>
            </div>
            <button
              class="w-12 h-12 rounded-full bg-white flex items-center justify-center"
              @click="setActiveFaq(index)"
            >
              <svg-icon
                name="plus"
                class="w-8 h-8"
                :class="{ 'rotate-45': activeArticleId === faq.id }"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { faqService } from "@/services";

export default defineComponent({
  name: "FaqSection",
  data() {
    return {
      faqItems: [],
      loading: true,
      error: null,
      activeIndex: -1,
      activeArticleId: null,
    };
  },
  computed: {
    activeFaq() {
      return this.activeIndex >= 0 ? this.faqItems[this.activeIndex] : null;
    },
  },
  methods: {
    async fetchFaqs() {
      try {
        this.loading = true;
        this.error = null;
        const response = await faqService.getFaqList({ limit: 7 });
        console.log(response);
        this.faqItems = response.results || [];
      } catch (err) {
        console.error("Ошибка при загрузке FAQ:", err);
        this.error = this.$t("faq.error");
      } finally {
        this.loading = false;
      }
    },
    toggleArticle(id) {
      if (this.activeArticleId === id) {
        this.activeArticleId = null;
      } else {
        this.activeArticleId = id;
        // articleService.getArticle(id).then((response) => {
        //   const faq = this.faqItems.find((faq) => faq.id === id);
        //   faq.content = response.text;
        // });
      }
    },
    async setActiveFaq(index) {
      this.activeIndex = index;
      const faq = this.faqItems[index];

      // Если есть необходимость загрузить детальную информацию о вопросе
      if (faq && !faq.content && faq.id) {
        try {
          const details = await faqService.getFaqItem(faq.id);
          // Обновляем объект с полученными данными
          this.faqItems[index] = { ...faq, ...details };
        } catch (err) {
          console.error(`Ошибка при загрузке деталей вопроса ${faq.id}:`, err);
        }
      }
    },
    closeActiveFaq() {
      this.activeIndex = -1;
    },
  },
  created() {
    this.fetchFaqs();
  },
});
</script>

<style scoped>
.text-primary {
  color: #3db076;
}

.bg-primary {
  background-color: #3db076;
}

/* Анимация для FAQ */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
  opacity: 1;
  overflow: hidden;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  max-height: 0;
}
</style>
